// Define LightTheme App
import { createTheme } from '@mui/material'

export default createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: 'f2f2f2',
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: 'f2f2f2',
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            backgroundColor: 'f2f2f2',
            outline: 'none',
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: '#959595',
          },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: '#959595',
          },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#959595',
          },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: '#2b2b2b',
          },
        },
      },
    },
  },

  palette: {
    mode: 'light',
    background: {
      default: '#a9a9a9',
      paper: '#fff',
    },
    common: {
      black: '#fff',
      white: 'linear-gradient(rgb(254 255 255), #aaaaaa)',
    },
    primary: {
      main: '#eb1a24',
    },
    info: {
      main: '#00008B',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      'Vazir',
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    caption: {
      fontSize: '0.35rem',
      fontWeight: 'bold',
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    subtitle2: {
      fontSize: '0.80rem',
    },
  },
})
